// src/constants/accounts-portal-query-keys.ts
var LIST_PAYMENT_METHODS_QUERY_KEY = "payment_methods";
var LIST_SPECIAL_OCCASIONS_QUERY_KEY = "special-occasions";
var INITIATE_2FA_QUERY_KEY = "initiate-2FA";
var GET_AUTH_MANAGEMENT_STATUS_QUERY_KEY = "auth-management-status";
var GET_PERSONALIZATION_STATUS_QUERY_KEY = "personalization-status";
var GET_ADDRESSES_QUERY_KEY = "addresses";
var GET_LOCKOUT_SESSION_QUERY_KEY = "lockout-session";
var GET_ASSIGNED_PERSONAS_QUERY_KEY = "assigned-personas";
var GET_ACCOUNT_ROLES_QUERY_KEY = "account-roles";
var GET_SOCIAL_OATH_STATUS_QUERY_KEY = "social-oauthProviders-Status";
var GET_USER_PROFILE_QUERY_KEY = "user-profile-details";
var GET_PRIVACY_TERMS_SERVICE_QUERY_KEY = "privacy-terms-service";
var GET_PRIVACY_DATA_PRIVACY_POLICY_QUERY_KEY = "privacy-data-policy";
var GET_PRIVACY_DATA_PROCESS_QUERY_KEY = "privacy-data-process";
var GET_PRIVACY_COOKIE_POLICY_QUERY_KEY = "privacy-cookie-policy";

// src/constants/common.ts
var NEXT_LOCALE_COOKIE = "NEXT_LOCALE";
var REDIRECT_AFTER_LOGIN_COOKIE = "REDIRECT_AFTER_LOGIN";
var AUTH0_PAYLOAD = "auth0_payload";
var GET_PROFILE_QUERY_KEY = "user-profile";
var INVEST_POPUP_STORAGE_KEY = "investPopupShown";
var BANKS = [
  { label: "National Bank of Egypt (NBE)", value: "nbe" },
  { label: "Banque Misr", value: "banque_misr" },
  { label: "Commercial International Bank (CIB)", value: "cib" },
  { label: "QNB Al Ahli", value: "qnb_al_ahli" },
  { label: "Arab African International Bank (AAIB)", value: "aaib" },
  { label: "Banque du Caire", value: "banque_du_caire" },
  { label: "Bank of Alexandria (AlexBank)", value: "alexbank" },
  { label: "United Bank of Egypt", value: "united_bank" },
  { label: "Faisal Islamic Bank of Egypt", value: "faisal_islamic" },
  { label: "HSBC Bank Egypt", value: "hsbc_egypt" }
];
var WALLETS = [{ value: "fawry", label: "Fawry" }];
var SUPPORTED_CURRENCIES = [
  { code: "EGP", symbol: "\u062C.\u0645", name: "Egyptian Pound" },
  { code: "USD", symbol: "$", name: "US Dollar" }
];
var CURRENCY_MAP = {
  EGP: "\u062C.\u0645",
  USD: "$"
};
var DEFAULT_CURRENCY = "USD";
var PAYMENT_STATE = {
  INITIAL: "initial",
  PROCESSING: "processing",
  SUCCESS: "success",
  FAILED: "failed"
};

// src/constants/contentful-query-keys.ts
var CONTENTFUL_OWNER_OFFER_LIST_KEY = "ownerDashboardOffersPageOfferList";
var CONTENTFUL_OWNER_OFFER_SLIDER_KEY = "ownerDashboardOffersPageOfferSlider";
var CONTENTFUL_OWNER_HELP_GUIDE_FAQ_KEY = "ownerDashboardHelpGuidePageFaq";
var CONTENTFUL_OWNER_HELP_GUIDE_FAQ_TOPIC_KEY = "ownerDashboardHelpGuideTopics";
var CONTENTFUL_OWNER_HELP_GUIDE_TOP_ARTICLES_KEY = "partment2024";
var HOME_OFFER_CARDS = "partmentOwnerDashboardOffers";
var HOME_OFFER_CARDSLIDER = "ownerDashboardAdSlider";
var HOME_OFFER_BANNERSLIDER = "ownerDashboardHomeOfferBannerSlider";
var REFER_HOW_IT_WORKS_CONTENT_TYPE = "ownerReferAndEarnHowItWorks";
var REFER_TERMS_CONDITIONS_CONTENT_KEY = "ownerReferAndEarnTermsCondition";
var PRIVACY_TERMS_SERVICE_KEY = "privacyDataTermsService";
var PRIVACY_DATA_PRIVACY_POLICY_KEY = "privacyDataPrivacyPolicy";
var PRIVACY_DATA_PROCESS_KEY = "privacyDataDataProcessing";
var PRIVACY_COOKIE_POLICY_KEY = "privacyDataCookiePolicy";
var GLOBAL_PORTAL_HOME_PAGE_KEY = "globalPortalHomePageData";
var GLOBAL_PORTAL_LEARN_FROM_EXPERTS_KEY = "globalPortalLearnFromExperts";
var BRAND_FOOTER_KEY = "partmentBrandFooter";

// src/constants/owner-query-keys.ts
var OFFER_SLIDER_QUERY_KEY = "offer_slider";
var OFFERS_QUERY_KEY = "offers";
var HELP_GUIDE_TOP_ARTICLES_QUERY_KEY = "help_guide_top_articles";
var FAQS = "faqs";
var HOME_OFFER_FAQS = "ownerFaq";
var HOME_OFFER_SLIDER_QUERY_KEY = "home_offers_slider";
var HOME_OFFER_BANNER_QUERY_KEY = "home_offers_banner_slider";
var REFER_HOW_IT_WORKS_QUERY_KEY = "owner_refer_earn_how_it_works";
var REFER_TERMS_CONDITIONS_QUERY_KEY = "owner_refer_earn_terms_conditions";
var PROFILE_COMPLETION_PERCENTAGE_QUERY_KEY = "profile_completion_percentage";
var GLOBAL_PORTAL_HOME_PAGE_DATA_QUERY_KEY = "global_portal_home_page_data";
var GLOBAL_PORTAL_LEARN_FROM_EXPERTS_DATA_QUERY_KEY = "global_portal_learn_from_experts_data";
var STAYS_MY_BOOKINGS_PAGE_CONTENT = "staysMyBookingspageContent";

// src/constants/rental-marketplace-query-keys.ts
var PROPERTIES_QUERY_KEY = "properties_search";
var PROPERTIESLISTING_QUERY_KEY = "propertieslisting_search";
var PROPERTY_SEARCH_QUERY_KEY = "property-list";
var PROPERTY_QUICK_FEATURE_QUERY_KEY = "property_quick_feature";
var PROPERTY_DETAILS_QUERY_KEY = "property_details";
var PROPERTY_REVIEW_QUERY_KEY = "property_review";
var FOOTER_LOCATION_QUERY_KEY = "footer_location";
var OUR_HAPPY_GUEST_QUERY_KEY = "ourHappyGuest";
var MY_BOOKING_HISTORY_QUERY_KEY = "mybookingHistory";
var LUXURY_DESTINATIONS_QUERY_KEY = "luxuryDestinations";
var BANNER_QUERY_KEY = "banner";
var TRENDING_DESTINATIONS_QUERY_KEY = "trendingDestinations";
var HERO_BANNERS_QUERY_KEY = "heroBanners";
var SIMILAR_PROPERTIES_QUERY_KEY = "similarProperties";
var LOCATION_DROPDOWN_NEW_QUERY_KEY = "locationDropdownNew";

// src/enums/Address/index.ts
var AddressType = /* @__PURE__ */ ((AddressType2) => {
  AddressType2["ALL"] = "ALL";
  AddressType2["PRIMARY"] = "PRIMARY";
  AddressType2["BILLING"] = "BILLING";
  AddressType2["SHIPPING"] = "SHIPPING";
  AddressType2["PROPERTY"] = "PROPERTY";
  AddressType2["BUSINESS_REGISTERED"] = "BUSINESS_REGISTERED";
  AddressType2["BUSINESS_OPERATING"] = "BUSINESS_OPERATING";
  return AddressType2;
})(AddressType || {});

// src/enums/Notifications/index.ts
var NOTIFICATION_TYPE = /* @__PURE__ */ ((NOTIFICATION_TYPE2) => {
  NOTIFICATION_TYPE2["BOOKINGS"] = "bookings";
  NOTIFICATION_TYPE2["INVESTMENTS"] = "investments";
  NOTIFICATION_TYPE2["REFERRALS"] = "referrals";
  NOTIFICATION_TYPE2["OPPORTUNITY"] = "opportunity";
  return NOTIFICATION_TYPE2;
})(NOTIFICATION_TYPE || {});

// src/enums/Payment/index.ts
var TransactionStatus = /* @__PURE__ */ ((TransactionStatus2) => {
  TransactionStatus2[TransactionStatus2["Success"] = 1] = "Success";
  TransactionStatus2[TransactionStatus2["Failure"] = 2] = "Failure";
  return TransactionStatus2;
})(TransactionStatus || {});

// src/enums/Profile/index.ts
var PERSONA = /* @__PURE__ */ ((PERSONA2) => {
  PERSONA2["OWNER"] = "OWNER";
  PERSONA2["SELLER"] = "SELLER";
  PERSONA2["RENTER"] = "RENTER";
  return PERSONA2;
})(PERSONA || {});
var PROFILE_TYPE = /* @__PURE__ */ ((PROFILE_TYPE2) => {
  PROFILE_TYPE2["BROKER"] = "BROKER";
  PROFILE_TYPE2["LANDLORD"] = "LANDLORD";
  PROFILE_TYPE2["CO_OWNER"] = "CO-OWNER";
  PROFILE_TYPE2["INVESTOR"] = "INVESTOR";
  return PROFILE_TYPE2;
})(PROFILE_TYPE || {});
var ACCOUNT_ROLE = /* @__PURE__ */ ((ACCOUNT_ROLE2) => {
  ACCOUNT_ROLE2["BROKER"] = "BROKER";
  ACCOUNT_ROLE2["LANDLORD"] = "LANDLORD";
  ACCOUNT_ROLE2["CO_OWNER"] = "CO_OWNER";
  ACCOUNT_ROLE2["FRACTIONAL_INVESTOR"] = "FRACTIONAL_INVESTOR";
  ACCOUNT_ROLE2["RENTER_CUSTOMER"] = "RENTER_CUSTOMER";
  ACCOUNT_ROLE2["PROPERTY_DEVELOPER"] = "PROPERTY_DEVELOPER";
  ACCOUNT_ROLE2["INDIVIDUAL_SELLER"] = "INDIVIDUAL_SELLER";
  return ACCOUNT_ROLE2;
})(ACCOUNT_ROLE || {});

// src/enums/Routes/index.ts
var ROUTE_PREFIX = /* @__PURE__ */ ((ROUTE_PREFIX2) => {
  ROUTE_PREFIX2["OWNER"] = "/owner";
  return ROUTE_PREFIX2;
})(ROUTE_PREFIX || {});
var APP_NAME = /* @__PURE__ */ ((APP_NAME2) => {
  APP_NAME2["GLOBAL_PORTAL"] = "global-portal";
  APP_NAME2["SELLER"] = "seller";
  APP_NAME2["CO-OWNER"] = "co-owner";
  APP_NAME2["DEVELOPER"] = "developer";
  APP_NAME2["RENTAL_MARKETPLACE"] = "rental-marketplace";
  APP_NAME2["LANDLOARD"] = "landloard";
  APP_NAME2["LANDLORD"] = "landlord";
  APP_NAME2["INDIVIDUAL-LANDLOARD"] = "individual-landloard";
  APP_NAME2["RENTER"] = "renter";
  APP_NAME2["PARENT-BRAND"] = "parent-brand";
  APP_NAME2["BROKER"] = "broker";
  APP_NAME2["ACCOUNTS_PORTAL"] = "accounts-portal";
  return APP_NAME2;
})(APP_NAME || {});

// src/interfaces/accounts-portal/Preferences/special-occasions.interface.ts
var OccasionType = /* @__PURE__ */ ((OccasionType2) => {
  OccasionType2["BIRTHDAY"] = "BIRTHDAY";
  OccasionType2["ANNIVERSARY"] = "ANNIVERSARY";
  OccasionType2["CUSTOM"] = "CUSTOM";
  return OccasionType2;
})(OccasionType || {});
var Relation = /* @__PURE__ */ ((Relation2) => {
  Relation2["SELF"] = "SELF";
  Relation2["SPOUSE"] = "SPOUSE";
  Relation2["PARTNER"] = "PARTNER";
  Relation2["PARENT"] = "PARENT";
  Relation2["CHILD"] = "CHILD";
  Relation2["SIBLING"] = "SIBLING";
  Relation2["FRIEND"] = "FRIEND";
  Relation2["OTHER"] = "OTHER";
  return Relation2;
})(Relation || {});
export {
  ACCOUNT_ROLE,
  APP_NAME,
  AUTH0_PAYLOAD,
  AddressType,
  BANKS,
  BANNER_QUERY_KEY,
  BRAND_FOOTER_KEY,
  CONTENTFUL_OWNER_HELP_GUIDE_FAQ_KEY,
  CONTENTFUL_OWNER_HELP_GUIDE_FAQ_TOPIC_KEY,
  CONTENTFUL_OWNER_HELP_GUIDE_TOP_ARTICLES_KEY,
  CONTENTFUL_OWNER_OFFER_LIST_KEY,
  CONTENTFUL_OWNER_OFFER_SLIDER_KEY,
  CURRENCY_MAP,
  DEFAULT_CURRENCY,
  FAQS,
  FOOTER_LOCATION_QUERY_KEY,
  GET_ACCOUNT_ROLES_QUERY_KEY,
  GET_ADDRESSES_QUERY_KEY,
  GET_ASSIGNED_PERSONAS_QUERY_KEY,
  GET_AUTH_MANAGEMENT_STATUS_QUERY_KEY,
  GET_LOCKOUT_SESSION_QUERY_KEY,
  GET_PERSONALIZATION_STATUS_QUERY_KEY,
  GET_PRIVACY_COOKIE_POLICY_QUERY_KEY,
  GET_PRIVACY_DATA_PRIVACY_POLICY_QUERY_KEY,
  GET_PRIVACY_DATA_PROCESS_QUERY_KEY,
  GET_PRIVACY_TERMS_SERVICE_QUERY_KEY,
  GET_PROFILE_QUERY_KEY,
  GET_SOCIAL_OATH_STATUS_QUERY_KEY,
  GET_USER_PROFILE_QUERY_KEY,
  GLOBAL_PORTAL_HOME_PAGE_DATA_QUERY_KEY,
  GLOBAL_PORTAL_HOME_PAGE_KEY,
  GLOBAL_PORTAL_LEARN_FROM_EXPERTS_DATA_QUERY_KEY,
  GLOBAL_PORTAL_LEARN_FROM_EXPERTS_KEY,
  HELP_GUIDE_TOP_ARTICLES_QUERY_KEY,
  HERO_BANNERS_QUERY_KEY,
  HOME_OFFER_BANNERSLIDER,
  HOME_OFFER_BANNER_QUERY_KEY,
  HOME_OFFER_CARDS,
  HOME_OFFER_CARDSLIDER,
  HOME_OFFER_FAQS,
  HOME_OFFER_SLIDER_QUERY_KEY,
  INITIATE_2FA_QUERY_KEY,
  INVEST_POPUP_STORAGE_KEY,
  LIST_PAYMENT_METHODS_QUERY_KEY,
  LIST_SPECIAL_OCCASIONS_QUERY_KEY,
  LOCATION_DROPDOWN_NEW_QUERY_KEY,
  LUXURY_DESTINATIONS_QUERY_KEY,
  MY_BOOKING_HISTORY_QUERY_KEY,
  NEXT_LOCALE_COOKIE,
  NOTIFICATION_TYPE,
  OFFERS_QUERY_KEY,
  OFFER_SLIDER_QUERY_KEY,
  OUR_HAPPY_GUEST_QUERY_KEY,
  OccasionType,
  PAYMENT_STATE,
  PERSONA,
  PRIVACY_COOKIE_POLICY_KEY,
  PRIVACY_DATA_PRIVACY_POLICY_KEY,
  PRIVACY_DATA_PROCESS_KEY,
  PRIVACY_TERMS_SERVICE_KEY,
  PROFILE_COMPLETION_PERCENTAGE_QUERY_KEY,
  PROFILE_TYPE,
  PROPERTIESLISTING_QUERY_KEY,
  PROPERTIES_QUERY_KEY,
  PROPERTY_DETAILS_QUERY_KEY,
  PROPERTY_QUICK_FEATURE_QUERY_KEY,
  PROPERTY_REVIEW_QUERY_KEY,
  PROPERTY_SEARCH_QUERY_KEY,
  REDIRECT_AFTER_LOGIN_COOKIE,
  REFER_HOW_IT_WORKS_CONTENT_TYPE,
  REFER_HOW_IT_WORKS_QUERY_KEY,
  REFER_TERMS_CONDITIONS_CONTENT_KEY,
  REFER_TERMS_CONDITIONS_QUERY_KEY,
  ROUTE_PREFIX,
  Relation,
  SIMILAR_PROPERTIES_QUERY_KEY,
  STAYS_MY_BOOKINGS_PAGE_CONTENT,
  SUPPORTED_CURRENCIES,
  TRENDING_DESTINATIONS_QUERY_KEY,
  TransactionStatus,
  WALLETS
};
